/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-04-23 09:15:32
 * Modified By: Val Liu
 * -----
 */

import { IUITagInput, IUITagResult, UITag } from "../core";
import { uiValidator } from "../ui-validator";
import config from "@/config/default/framework";

// @uiValidatorAfter - add `{ state: true }`,
//  if the form element finally fallback to null.

@UITag.set({
    default: config.validatorAfter,
})
export class uiValidatorAfter extends uiValidator {
    allowNullRule: boolean = true; /// default: show true state

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        /// allow null
        /// "isDefault" and null share the same result.
        if (input.rule == null) {
            return {
                props: {
                    validatorAfter: () => ({
                        state: true,
                    }),
                },
            };
        }

        /// normal
        const result = super.parse(input);
        if (result == null) return result;

        return {
            props: { validatorAfter: result.props?.validator },
        };
    }
}
